import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TrustAnchorVO} from '../../../../generate/TopLevelDomainVO';
import {FormArray, FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {DSAlgorithm, DSALGORITHMS } from '../../../../model/DSAlgoritm';
import {DigestType, DIGESTTYPES} from '../../../../model/DigestType';
import {TrustAnchorsValidatorsService} from '../../../../validators/service/trust-anchors-validators.service';
import {ErrorVO} from '../../../../generate/ErrorVO';
import {values} from 'lodash-es';
import {UtilService} from '../../../../util/util.service';
import {AppConfigService} from "../../../../services/app.config.service";

@Component({
  selector: 'lib-ds-records-edit',
  templateUrl: './ds-records-edit.component.html',
  styleUrls: ['./ds-records-edit.component.scss']
})
export class DsRecordsEditComponent implements OnInit {
  @Input()
  trustAnchors: Array<TrustAnchorVO>;

  @Input()
  newDelegation: boolean;

  @Output()
  trustAnchorsEventOutPut = new EventEmitter<Array<TrustAnchorVO>>();

  @Output()
  cancelOutPut = new EventEmitter<boolean>();
  editDsRecordsForm: FormGroup;
  keyAlgs: DSAlgorithm[] = DSALGORITHMS;
  digestTypes: DigestType[] = values(DIGESTTYPES);
  errors: ErrorVO;
  emptyTrustAnchorsErrorMessage: string;
  visitCount = 0;

  get formDsRecords(): FormArray {
    return this.editDsRecordsForm.get('formDsRecords') as FormArray;
  }

  keyTag(index: number): FormControl {
    return this.getDsField(index, 'keyTag');
  }

  digest(index: number): FormControl {
    return this.getDsField(index, 'digest');
  }

  getDsField(index: number, name: string): FormControl {
    const controls = this.formDsRecords.controls[index] as FormGroup;
    return controls.controls[name] as FormControl;
  }

  constructor(private formBuilder: FormBuilder,
              private validatorService: TrustAnchorsValidatorsService,
              private util: UtilService,
              private appConfigService: AppConfigService) {
  }

  ngOnInit(): void {
    this.editDsRecordsForm = this.formBuilder.group({
      formDsRecords: this.initDsRecordsArray()
    });

    this.formDsRecords.valueChanges.subscribe((dsRecords) => {
      for (let i = 0; i < dsRecords.length; i++) {
        const keyTag = this.keyTag(i);
        const digest = this.digest(i);
        const dsRecord = dsRecords[i];
        const errors = this.validatorService.validateTrustAnchor(dsRecord, dsRecords, DIGESTTYPES[dsRecord.digestType].reqLength);
        setTimeout(() => {
          keyTag.setErrors(null);
          digest.setErrors(null);
          if (errors.size > 0) {
            keyTag.setErrors(errors.get('keyTag'));
            digest.setErrors(errors.get('keyDigest'));
          }
        });
      }
    });
  }

  onSubmit(): void {
    if (!this.showErrorMessageForNewDelegation()) {
      this.validatorService.serverValidation(this.formDsRecords.getRawValue()).subscribe(data => {
        if (data == null) {
          this.trustAnchors = this.formDsRecords.getRawValue();
          this.trustAnchorsEventOutPut.emit(this.trustAnchors);
        } else {
          this.errors = data;
          for (let i = 0; i < this.formDsRecords.controls.length; i++) {
            this.keyTag(i).setErrors(this.getTrustAnchorValidationError(this.digest(i).value, 'keyTag').join(', ') as any);
            let errorMessages = this.getTrustAnchorValidationError(this.digest(i).value, 'digest');
            if (i + 1 === this.formDsRecords.controls.length) {
              errorMessages = errorMessages.concat(this.getTrustAnchorValidationError('$global$', 'digest'));
            }
            this.digest(i).setErrors(errorMessages.join(', ') as any);
          }
        }
      });
    }
  }

  private initDsRecordsArray(): FormArray {
    const formArr = new FormArray([]);
    for (const dsRecord of this.trustAnchors) {
      formArr.push(this.formBuilder.group({
        keyTag: dsRecord.keyTag,
        algorithm: dsRecord.algorithm,
        digestType: dsRecord.digestType,
        digest: dsRecord.digest
      }));
    }
    return formArr;
  }

  removeDsRecord(i: number): void {
    this.formDsRecords.removeAt(i);
  }

  addAdditionalDS(): void {
    this.formDsRecords.push(this.formBuilder.group({
      keyTag: '',
      algorithm: this.keyAlgs[0].name,
      digestType: DIGESTTYPES.SHA1.name,
      digest: ''
    }));
  }

  cancel(): void {
    this.cancelOutPut.emit(true);
  }

  getTrustAnchorValidationError(name: string, field: string): string[] {
    let listOfErrors: Array<string> = [];
    const error: ErrorVO = this.util.getFieldError(name, this.errors);
    const hostError: ErrorVO = this.util.getFieldError(field, error);
    if (hostError != null) {
      listOfErrors = hostError.errorMessages;
    }

    return listOfErrors;
  }

  showErrorMessageForNewDelegation(): boolean {
    if (this.newDelegation && this.formDsRecords.length === 0 && this.visitCount === 0) {
      this.emptyTrustAnchorsErrorMessage = 'You are trying to submit a new delegation request without Delegation Signer Records. If you still want to continue, click Next.';
      this.visitCount++;
      return true;
    }else{
      this.emptyTrustAnchorsErrorMessage = null;
      return false;
    }
  }
}
